module.exports = __webpack_public_path__ + "img/icon-form-username.79c18aa0.svg";